var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 53,
    fill: "url(#pattern0_40_154)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_40_154",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_40_154",
    transform: "matrix(0.00981481 0 0 0.01 0.00925926 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_40_154",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE50lEQVR4nO2dy4sVRxSHf1FGBIfEURFn4p+Qx8rEZS81oKM4Zu9OkoVRkoVuMm7i0se/4IBLRbK2QRjFF+587aIhCUSi8Q5kNqal4Axciup63O6+fU71+aDgMreq7u3zzanqR91uQFEURVF4MANgCcAKgKcA1gCM6PUKvWfq9EFllexZBPDCseF2eUF1p001FCGbAFyIEDFe/gfwC7WdFtVQhKTKGC9GyrSohiBkkf7bxzf0PwAXAXwFYBsV8/oSvWdnyuGavqvMyysAB9uUMeOYM34D8JmnzecAXjrmFNdEXw2gmFi0xpIjM3wyxqWsW22XBiqkalPIitWxGaZiuWy1veqoUw2ktMYzq+N9CW2/ttqavoZCZ0JGVsezCW1nrbamr6HQmZB3DYR8bLX9F8OhmtaQZXZtY9mvQxY6n9TNcUYsVyIm9VzpLENcu71mlzbEl5G7vbnSmZC6A0OflC8SDgxzpTMhdadO1uk4Yz9N9LP0+oojM3ynTnKlUyGSTi4ORsgmCqydKdxOvw9GyAaHEy5QDW2Y6kWI6xLuiMoT2rXt8xLuIIUoYVRIrkLmAJwAcINOm6xZHf8J4EhEP0epbjXlsgbgLoDvAWyBYCFbAZwF8DZio98A2O7pazvVqXoujwAsQKAQ86XvJ27ssqe/ZQYyKioPe8qUiYUsOE5zVA2yhEt2VGPlOwgRYoapB47GZuw/RycIzWqSukAvR2RHaHhrmz0Ablrf4Q6ECDnraHjNcxEqFOxYaV3zqfUdzEU29kLmHBO4kfGRp00o4H1nxwZ7JQo54RimYi7P1gWdS3bsBfCrxCHrutXAzBkx1AU+lB3f0Cq+qodyEgKEPLcamItKsbiCH8qOvmTc7+m8WrKQJqtJQru2rrmjDxkPAMyjH5KFJDdIOPhzzR3TkjACsErDVJ9nnKcu5BMA/zj6eUt7cG1/njSmLqQuS+r2rFRIgFCAvqW54LXn7K49l/iOO1RIgFCA/hp773dPP8dI2t90yn3Sz8uN1oestgOoQgKokG7RDGGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCmGGCpEuxF55OO9ZPa7X1NNJjt8tq8FN+l2Fa/W4Ckmn8c8RQqUpqYsqqsxKkM308+E2OpwJ/NBHhUSyG8C9hkI2Vjia1fTHPfWGnCEvkcAMrRRfHXvsxO0EIeMrHP9QIXDJOIAWiBXSdr1JKTz/oeY98UgTUnqEmPfEI0lI4RBQ5pYlkoSUjuC7JIlGipDCE/isskSKkNIT9KyyRIKQIiLg2WSJBCFlRLCzyRLuQoqEQGeRJdyFlAlBziJLOAspJgiw+CzhLKScILjis4SrkKJBYEVnCVchZYOgis4SjkKKFgIqNks4CilbCKbYLOEmpGgxkCKzhJuQssUgiswSTkKKDgIoLks4CSk7CJ64LOEipOgwcKKyxL5JputmkjscgZ6rub/8pI9gLTsMmqgseWx92R8ddX5wCDnlqPeT4zESSiLnrSCuk5QFuuH9GcfzCjeeBHqa6iyQjHUGd7wWz67Ih7ukljcAdva9cVIxN798HxHk9wn1FvveqByk+O5ibe7de4ieWRi627XKaHH4Ok+T8Yj2wMzrn63hZyfND4+ozjt65JD5mw5TiqIoioLmfAChC6W4xycurwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon2);
export default __webpack_public_path__ + "static/media/cardIcon2.58e9d924943539131397bf854165e404.svg";
export { ForwardRef as ReactComponent };